import { baseCommand } from "./basecommand";

type divSceenextrastypename = "extras";

type divSceenextrasdatatype = {
    "type" : divSceenextrastypename;
    "data":{
        "count": number;
        "maxCount": number;
        "json": string;
    }
}

type pscommand<T> = {
    "type": T extends divSceenextrastypename ? T : never;
    "data": T extends divSceenextrastypename ? divSceenextrasdatatype : never;
};

export type dividesSceneExtrasCommand = pscommand<divSceenextrastypename>;

export class divideSceeneEtras extends baseCommand {
    public type: divSceenextrastypename = "extras";

    constructor(private extras: string) {
        super();
    }

    // private base64encode(srt: string) {
    //     unescape(encodeURIComponent(str))
    //     return btoa([...buffer].map(n => String.fromCharCode(n)).join(""));
    // }

    public divideString(jsonStr: string, chunksize: number) {
        const datasize = jsonStr.length;
        const maxcount = Math.ceil(datasize / chunksize);

        const result: divSceenextrasdatatype[] = [];
        let count = 0;
        for (let index = 0; index < datasize; index += chunksize) {
            const senddata : divSceenextrasdatatype = {
                "type": "extras",
                "data": {
                    "count": count,
                    "maxCount": maxcount,
                    "json": jsonStr.slice(index, index + chunksize)
                }
            };
            result.push(senddata);
            count++;
        }
        return result;
    }


    public object() {

        const ext : divSceenextrasdatatype = {
            "type":"extras",
            "data":{
                "count": 9999,
                "maxCount": 9999,
                "json": ""
            }
        };
        ;

        const baseSize = JSON.stringify(ext).length;
        const chunksize = this.MAXIMUM_SIZE_DATA_TO_SEND - baseSize;

        const base64str = btoa(JSON.stringify(this.extras));
        return this.divideString(base64str, chunksize);
    }
}
